<template>
	<div class="d-flex justify-center amelipro-menu">
		<AmeliproIconBtn
			btn-label="Menu du service"
			class="amelipro-menu__btn--open"
			icon="menuSquare"
			icon-bg-color="transparent"
			icon-color="ap-white"
			icon-hover-bg-color="transparent"
			icon-hover-color="ap-grey lighten-5"
			large
			@click.stop="drawer = !drawer"
		/>

		<VNavigationDrawer
			ref="modalContainer"
			v-model="drawer"
			app
			aria-label="Menu du service"
			aria-modal="true"
			color="ap-blue darken-2"
			hide-overlay
			role="dialog"
			temporary
			width="300"
		>
			<div
				class="d-flex justify-space-between align-center amelipro-menu__container"
			>
				<h2
					class="pa-1 mb-0 ap-white--text text-uppercase amelipro-menu__title"
				>
					{{ menuHeader }}
				</h2>

				<AmeliproIconBtn
					id="close-menu-btn"
					btn-label="Fermer le menu"
					class="mr-2 menu-btn-close"
					icon-bg-color="transparent"
					icon-color="ap-white"
					icon-hover-bg-color="transparent"
					icon-hover-color="ap-white"
					@click.stop="drawer = !drawer"
					@keydown.tab.shift.prevent="setFocus('return-home-menu-btn')"
				>
					<template #icon>
						{{ mdiClose }}
					</template>
				</AmeliproIconBtn>
			</div>

			<VDivider class="my-2 ap-white" />

			<ul class="list-style-none amelipro-menu__list">
				<li
					v-for="(item, index) in reactiveItems"
					:key="item.name"
					class="amelipro-menu__item"
				>
					<div v-if="item.children">
						<AmeliproBtn
							:id="`menu-btn__${item.id}`"
							:aria-controls="'niveau2-' + index"
							:aria-expanded="Boolean(item.actif).toString()"
							class="d-flex justify-space-between w-100 menu-btn"
							color="ap-blue darken-2"
							elevation="0"
							hover-color="ap-blue lighten-3"
							icon-bg-color="transparent"
							icon-hover-color="ap-blue darken-2"
							text-hover-color="ap-blue darken-2"
							tile
							@click="item.actif = !item.actif"
						>
							{{ item.name }}

							<template #icon>
								{{ item.actif ? mdiChevronDown : mdiChevronUp }}
							</template>
						</AmeliproBtn>

						<ul
							v-if="item.actif"
							:id="'niveau2-' + index"
							class="list-style-none amelipro-menu__list--level-2"
						>
							<li
								v-for="(subItem, indexBis) in item.children"
								:key="subItem.name"
								class="amelipro-menu__item--level-2"
							>
								<div v-if="subItem.children">
									<AmeliproBtn
										:id="`menu-btn__${subItem.id}`"
										:aria-controls="'niveau3-' + indexBis"
										:aria-expanded="Boolean(subItem.actif).toString()"
										class="w-100 menu-btn"
										color="ap-blue darken-2"
										elevation="0"
										hover-color="ap-blue lighten-3"
										icon-bg-color="transparent"
										icon-hover-color="ap-blue darken-2"
										text-hover-color="ap-blue darken-2"
										tile
										@click="subItem.actif = !subItem.actif"
									>
										{{ subItem.name }}

										<template #icon>
											{{ subItem.actif ? mdiChevronDown : mdiChevronUp }}
										</template>
									</AmeliproBtn>

									<ul
										v-if="subItem.actif"
										:id="'niveau3-' + indexBis"
										class="list-style-none amelipro-menu__list--level-3"
									>
										<li
											v-for="subSubItem in subItem.children"
											:key="subSubItem.name"
											class="amelipro-menu__item--level-3"
										>
											<div>
												<AmeliproBtn
													:id="`menu-btn__${subSubItem.id}`"
													class="w-100 menu-btn"
													color="ap-blue darken-2"
													elevation="0"
													hover-color="ap-blue lighten-3"
													:href="subSubItem.href"
													icon-bg-color="transparent"
													icon-hover-color="ap-blue darken-2"
													text-hover-color="ap-blue darken-2"
													tile
													:to="subSubItem.to"
												>
													{{ subSubItem.name }}
												</AmeliproBtn>
											</div>
										</li>
									</ul>
								</div>

								<div
									v-else
									:id="'niveau2-' + index"
								>
									<AmeliproBtn
										:id="`menu-btn__${subItem.id}`"
										class="w-100 menu-btn"
										color="ap-blue darken-2"
										elevation="0"
										hover-color="ap-blue lighten-3"
										:href="subItem.href"
										icon-bg-color="transparent"
										icon-hover-color="ap-blue darken-2"
										text-hover-color="ap-blue darken-2"
										tile
										:to="subItem.to"
									>
										{{ subItem.name }}
									</AmeliproBtn>
								</div>
							</li>
						</ul>
					</div>

					<div v-else>
						<AmeliproBtn
							:id="`menu-btn__${item.id}`"
							class="w-100 menu-btn"
							color="ap-blue darken-2"
							elevation="0"
							hover-color="ap-blue lighten-3"
							:href="item.href"
							icon-bg-color="transparent"
							icon-hover-color="ap-blue darken-2"
							text-hover-color="ap-blue darken-2"
							tile
							:to="item.to"
						>
							{{ item.name }}
						</AmeliproBtn>
					</div>
				</li>
			</ul>

			<VDivider class="my-2 ap-white" />

			<div>
				<AmeliproBtn
					id="return-home-menu-btn"
					class="w-100 pa-0 home-menu-btn"
					color="ap-blue darken-2"
					elevation="0"
					hover-color="ap-blue darken-2"
					:href="ameliproHref"
					text-color="ap-white"
					text-hover-color="ap-blue darken-2"
					tile
					@keydown.tab.exact.prevent="setFocus('close-menu-btn')"
				>
					<img
						alt="Accueil Amelipro"
						Cgu
						class="home-menu-btn__img"
						src="../../assets/img/logo-menu.svg"
					>
				</AmeliproBtn>
			</div>
		</VNavigationDrawer>
	</div>
</template>

<script setup lang="ts">
	import { PropType, onMounted, reactive, ref } from 'vue';
	import { mdiChevronDown, mdiChevronUp, mdiClose } from '@mdi/js';
	import AmeliproBtn from '../AmeliproBtn';
	import AmeliproIconBtn from '../AmeliproIconBtn';
	import { AmeliproMenuItem } from './types';
	import { RawLocation } from 'vue-router';

	const props = defineProps({
		homeHref: {
			type: String,
			default: undefined,
		},
		ameliproHref: {
			type: String,
			default: undefined,
		},
		homeTo: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
		items: {
			type: Array as PropType<AmeliproMenuItem[]>,
			default: () => [],
		},
		menuHeader: {
			type: String,
			default: 'Titre du service',
		},
	});

	//const reactiveItems = reactive<AmeliproMenuItem[]>(props.items);
	// Maj JR pour éviter warning
	const reactiveItems = props.items;

	const drawer = ref(false);
	const setFocus = (id: string): void => {
		let element;

		if (id === 'close-menu-btn') {
			element = document.querySelector('#close-menu-btn') as HTMLElement;
			if (element !== null) {
				element.focus();
			}
		} else if (id === 'return-home-menu-btn') {
			element = document.querySelector('#return-home-menu-btn') as HTMLElement;
			if (element !== null) {
				element.focus();
			}
		}
	};

	const emit = defineEmits(['escape']);
	const closeDrawer = (event: KeyboardEvent): void => {
		if (event.code === 'Escape' && drawer.value) {
			drawer.value = false;
			emit('escape');
		}
	};

	defineExpose([setFocus]);

	onMounted(() => {
		window.addEventListener('keydown', closeDrawer);
	});
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
}

.v-btn {
  min-height: unset !important;
  padding: 0.5rem 1rem !important;
  border-radius: 0 !important;
  font-size: $font-size-sm;

  &.amelipro-menu__btn--open {
    padding: 0 !important;
  }
}

.v-btn :deep(.amelipro-custom-btn) {
  justify-content: space-between;
  width: 100%;
}

.v-btn.home-menu-btn :deep(.amelipro-custom-btn) {
  justify-content: flex-start;
}

.menu-btn,
.home-menu-btn {
  &:focus {
    color: $ap-blue-darken2 !important;
    background-color: $ap-blue-lighten3 !important;
  }
}

.menu-btn {
  &:focus :deep(.v-icon) {
    color: $ap-blue-darken2 !important;
  }
}

.menu-btn-close {
  &:focus {
    outline: 1px dotted $ap-blue-lighten3;
  }
}

.amelipro-menu__item--level-2,
.amelipro-menu__item--level-3 {
  & .v-btn {
    font-size: $font-size-xs;
    text-transform: unset;
    font-weight: $ap-font-weight-regular;
  }
}

.amelipro-menu__item--level-2 {
  & .v-btn {
    padding: 0.5rem 1rem !important;
  }

  & .amelipro-menu__item--level-3 {
    & .v-btn {
      padding: 0.5rem 1rem 0.5rem 2rem !important;
      font-weight: $ap-font-weight-light;
    }
  }
}

.home-menu-btn__img {
  width: 7.375rem;
}
</style>
